@if (hostWidth) {
  <app-white-panel>
    <app-loading-skeleton class="w-full h-[56px]" [viewBox]="'0 0 ' + hostWidth + ' 56'">
      <svg:rect x="16" y="16" rx="4" ry="4" width="100" height="24" />
      <svg:rect [attr.x]="hostWidth - 16 - 57" y="20" rx="4" ry="4" width="57" height="16" />
    </app-loading-skeleton>
    <app-site-at-a-glance-loading-skeleton class="block w-full" />
  </app-white-panel>
}
